var comMapping = {
}
export {
	comMapping
}
